import axios from 'axios'
import config from '@/config'
import interceptorResponseSuccess from '@/services/interceptors/responseSuccess'
import interceptorResponseError from '@/services/interceptors/responseError'

const http = axios.create({
  baseURL: config.API_URL
})

http.interceptors.response.use(interceptorResponseSuccess, interceptorResponseError)

export default http
